<template>
  <div class="notice_global" v-if="isShow">
    <div class="content">
      <svg-icon type="close" class="icon-32" @click="hideBulletinBoardData()"></svg-icon>
      <p class="subject" v-html="title[selectLang] || title['zh']"></p>
      <div class="note">
        <span v-html="content[selectLang] || content['zh']"></span>
      </div>
    </div>
    <div class="footer">
      <SvgIcon type="globe" class="icon-18"></SvgIcon>
      <el-select v-model="selectLang" :placeholder="$t('batch_select')">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { apiRequest } from "@/serves/http";
import ApiPath from "@/serves/path";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      isShow: false,
      title: "",
      content: "",
      selectLang: ["zh", "en"].includes(localStorage.getItem("language")) ? localStorage.getItem("language") : "zh",
      options: [
        { label: "中文", value: "zh" },
        { label: "English", value: "en" },
      ],
    };
  },
  mounted() {
    this.fetchBulletinBoardData();
  },
  methods: {
    fetchBulletinBoardData() {
      apiRequest.get(ApiPath.get_bulletin_board).then((res) => {
        if (res?.data?.note || res?.data?.subject) {
          this.isShow = true;
          this.title = JSON?.parse(res?.data?.subject);
          this.content = JSON?.parse(res?.data?.note);
        }
      });
    },
    hideBulletinBoardData() {
      apiRequest.post(ApiPath.hide_bulletin_board).then((res) => {
        if (res?.errcode == 0) {
          this.isShow = false;
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.notice_global {
  position: fixed;
  z-index: 1000;
  bottom: 0;
  width: 100%;
  min-height: 108px;
  max-height: 60%;
  .icon-32 {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .subject {
    font-size: 18px;
    color: #faae56;
    margin-bottom: 8px;
    line-height: 140%;
  }
  .note {
    max-height: 375px;
    overflow-y: scroll;
    font-size: 16px;
    color: #ffffff;
    line-height: 24px;
    ::v-deep a {
      color: #fff;
      cursor: pointer;
      text-decoration: underline;
      font-weight: 600;
      &:hover {
        color: #fff;
      }
    }
  }
  .content {
    padding: 20px 48px;
    background-color: #2c2f46;
    opacity: 0.8;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    // padding: 20px 48px;
    background-color: #2c2f46;
    opacity: 0.9;
    ::v-deep .el-select {
      width: 90px;
      .el-input__inner {
        background-color: transparent;
        color: #ffffff;
        border: none;
        font-size: 16px;
        text-align: center;
        padding-left: 0;
      }
    }
  }
}
</style>